@if (formGroup) {
  <form [formGroup]="formGroup" class="flex flex-col gap-4">
    <div class="flex gap-3 items-start">
      <div>
        <mat-slide-toggle
          #toggler
          color="primary"
          formControlName="toleranceEnabled"
        >
          <span translate
            >CAMPAIGN_PERFORMANCE_FILTER_BEST_PRICE_TOLERANCE_1</span
          >
        </mat-slide-toggle>
        <div class="ml-12">
          <small>{{
            'CAMPAIGN_PERFORMANCE_FILTER_BEST_PRICE_TOLERANCE_DESCRIPTION'
              | translate
          }}</small>
        </div>
      </div>

      <em-more-info
        class="ml-auto"
        [description]="'CAMPAIGN_PERFORMANCE_FILTER_BEST_PRICE_DESCRIPTION'"
      ></em-more-info>
    </div>

    @if (formGroup.get('toleranceEnabled')?.value) {
      <em-input
        formControlName="tolerancePercent"
        [subscriptSizing]="'dynamic'"
        [min]="0"
        [max]="100"
        [step]="1"
        type="number"
        class="ml-12 w-72"
      >
        <ng-container emSuffix><mat-icon>percent</mat-icon></ng-container>
        <em-error>{{
          'SHARED_RANGE_FIELD_ERROR' | translate: {min: 1, max: 100}
        }}</em-error>
      </em-input>
    }
    <div class="option">
      <mat-slide-toggle
        formControlName="shippingCostsExcluded"
        #toggler
        color="primary"
      >
        <span translate
          >CAMPAIGN_PERFORMANCE_FILTER_BEST_PRICE_EXCLUDE_SHIPPING</span
        >
      </mat-slide-toggle>
    </div>

    <div class="option">
      <mat-slide-toggle formControlName="excludeProducts" color="primary">
        <span>{{
          'CAMPAIGN_PERFORMANCE_FILTER_EXCLUDE_PRODUCTS_LABEL' | translate
        }}</span>
      </mat-slide-toggle>
    </div>
  </form>
}
